module.exports = __webpack_public_path__ + "img/NetworkPenetration.5a3c8e8b.jpg";